import { noop } from "../utils/noop.js";
import { defaultInternalLogger } from "./const.js";
import { defaultUnpatchedConsole } from "../unpatchedConsole/const.js";
//#region src/internalLogger/createInternalLogger.ts
function createInternalLogger(unpatchedConsole = defaultUnpatchedConsole, internalLoggerLevel = 1) {
	const internalLogger = defaultInternalLogger;
	if (internalLoggerLevel > 0) {
		internalLogger.error = internalLoggerLevel >= 1 ? function(...args) {
			unpatchedConsole.error(`${internalLogger.prefix}\n`, ...args);
		} : noop;
		internalLogger.warn = internalLoggerLevel >= 2 ? function(...args) {
			unpatchedConsole.warn(`${internalLogger.prefix}\n`, ...args);
		} : noop;
		internalLogger.info = internalLoggerLevel >= 3 ? function(...args) {
			unpatchedConsole.info(`${internalLogger.prefix}\n`, ...args);
		} : noop;
		internalLogger.debug = internalLoggerLevel >= 4 ? function(...args) {
			unpatchedConsole.debug(`${internalLogger.prefix}\n`, ...args);
		} : noop;
	}
	return internalLogger;
}
//#endregion
export { createInternalLogger };

//# sourceMappingURL=createInternalLogger.js.map